import styled, {css} from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import {hoverRaiseWithOverflow} from "@irati/ui/src/global/css/animations"
import {StyledFeedItem} from "./FeedItem"

export const StyledFeed = styled(Card)`
  ${({theme}) => css`
    position: relative;
    padding: 0;
    margin-top: ${theme.spacing.two};
    background: transparent;
    box-shadow: none;
    > div {
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing.two};
    }
    ${StyledFeedItem} {
      background-color: ${theme.colors.greys.white};
      border-radius: ${theme.border.radius.large};
      ${hoverRaiseWithOverflow}
    }
  `}
`
